import React from "react";
import "./button.css";

const ButtonComponent = ({
  buttonText,
  type = "filled",
  variant = "normal", // Added variant prop for rounded button
  onClick,
  style,
}) => {
  return (
    <button
      className={`custom-button ${
        type === "filled"
          ? "filled"
          : type === "yellowOutlined"
          ? "yellow-outlined"
          : "transparent"
      } ${variant === "rounded" ? "rounded" : ""}`} // Conditionally apply 'rounded' class
      onClick={onClick}
      style={{
        color: type === "yellowOutlined" ? "#fdb426" : "#FFFFFF", // Yellow text for outlined button
        ...style,
      }}
    >
      {buttonText}
    </button>
  );
};

export default ButtonComponent;
